import { yupResolver } from '@hookform/resolvers/yup';
import Close from '@mui/icons-material/Close';
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	Typography,
	useTheme,
} from '@mui/material';
import {
	DefaultValues,
	FormProvider,
	SubmitHandler,
	useForm,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import i18n from '@/i18n';
import * as Yup from 'yup';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import AppDropDownMenu from '@/common/components/form-inputs/AppDropDownMenu';
import { useLocation, useParams } from 'react-router-dom';
import { useGetStaffAllListQuery } from '@/api/common';
import { useSelector } from 'react-redux';
import {
	useClearAllCaseWorkersMutation,
	useTransferCaseWorkersMutation,
} from '@/api/member-management/admissionRequest';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import { selectMyInfo } from '@/pages/auth/authSlice';

interface Props {
	open: boolean;
	onClose: () => void;
	details: any;
}

const ClearAllCaseWorkersDialog = (props: Props) => {
	const { open, onClose, details } = props;
	const { t } = useTranslation();
	const [clearAllCaseWorkers] = useClearAllCaseWorkersMutation();
	const { admissionRequestId } = useParams();
	const location = useLocation();
	const memberType = i18n.t(
		location.pathname.includes('admission-request-list')
			? 'member.admissionRequestLabel'
			: 'member.memberDetailsLabel'
	);

	const userInfo = useSelector(selectMyInfo);

	const { data: staffList }: any = useGetStaffAllListQuery(
		userInfo?.currentBranch?.id || '',
		{
			refetchOnMountOrArgChange: true,
			skip: !userInfo?.currentBranch,
		}
	);
	console.log(details);
	const defaultValues: DefaultValues<any> = details || {};

	const formSchema = Yup.object().shape({});

	const methods = useForm<any>({
		defaultValues,
		resolver: yupResolver(formSchema),
	});

	const handleClose = () => {
		methods.reset({});
		onClose();
	};
	const onSubmit: SubmitHandler<any> = async (data) => {
		const response = await clearAllCaseWorkers({
			responsibleCaseWorkerId: data.responsibleCaseWorkerId,
			relievingWorkerId: data.relievingWorkerId,
			sharedWithProfessionalList: data.sharedWithProfessionalList,
			id: admissionRequestId,
		});
		if ('data' in response) {
			enqueueSnackbar(
				t('snackbar.clearAllCaseWorkersSuccess', { type: memberType }),
				{
					variant: 'success',
					anchorOrigin: { horizontal: 'center', vertical: 'top' },
					autoHideDuration: 3000,
					action: (key) => {
						return <CloseIcon onClick={() => closeSnackbar(key)} />;
					},
				}
			);
			handleClose();
		}
	};

	return (
		<Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
				<DialogTitle variant='h5'>
					{t('button.clearAllCaseWorkers')}
				</DialogTitle>
				<IconButton
					aria-label='close'
					onClick={handleClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<Close />
				</IconButton>
				<DialogContent>
					<Typography variant='body2' sx={{ marginBottom: '12px' }}>
						{t('member.clearAllCaseWorkersText')}
					</Typography>
					<FormProvider {...methods}>
						<form onSubmit={methods.handleSubmit(onSubmit)}>
							<Grid
								container
								spacing={2}
								marginTop={0}
								marginBottom={2}
								alignItems='center'
							>
								<Grid size={12}>
									<AppDropDownMenu
										disabled
										control={methods.control}
										name='responsibleCaseWorkerId'
										label={t('member.caseWorker') + '*'}
										options={staffList?.data || []}
									/>
								</Grid>
								<Grid size={12}>
									<AppDropDownMenu
										disabled
										optional={true}
										control={methods.control}
										name='relievingWorkerId'
										label={t('member.relievingWorker')}
										options={staffList?.data || []}
									/>
								</Grid>
								<Grid size={12}>
									<AppMultipleDropDownMenu
										disabled
										control={methods.control}
										name='sharedWithProfessionalList'
										label={t('member.sharedWithProfessionals')}
										options={staffList?.data || []}
									/>
								</Grid>
							</Grid>
						</form>
					</FormProvider>
				</DialogContent>
				<DialogActions>
					<Button sx={{ textTransform: 'none' }} onClick={() => handleClose()}>
						{t('button.cancel')}
					</Button>
					<Button
						type='submit'
						variant='contained'
						onClick={methods.handleSubmit(onSubmit)}
					>
						{t('button.confirm')}
					</Button>
				</DialogActions>
		</Dialog>
	);
};

export default ClearAllCaseWorkersDialog;
